import axios, { AxiosRequestConfig } from "axios";
import config from "../config";

// default
axios.defaults.baseURL = config.API_URL;

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.get["Content-Type"] = "application/json";
axios.defaults.headers.get["Accept"] = "application/json";

axios.interceptors.request.use(function (config: any) {
  const token = JSON.parse(
    localStorage.getItem("sb-auth-token") || "{}"
  )?.access_token;
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

// intercepting to capture errors
axios.interceptors.response.use(
  function (response: any) {
    return response.data ? response.data : response;
  },
  function (error: any) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error?.response?.status) {
      case 401:
        window.location.href = "/expirated";
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error?.response?.data?.message || error?.message || error;
    }
    return Promise.reject({
      message,
      success: error?.response?.data?.success,
      planLimit: error?.response?.data?.planLimit,
      code: error?.response?.data?.code,
    });
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: any) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = (url: string, params?: {}): any => {
    return axios.get(url, params);
  };

  /**
   * post given data to url
   */
  create = (url: string, data?: {}): any => {
    return axios.post(url, data);
  };

  /**
   * post given data to url
   */
  stream = (url: string, data?: {}): any => {
    return axios.post(url, data);
  };

  /**
   * Updates data
   */
  update = (url: string, data?: {}): any => {
    return axios.put(url, data);
  };

  /**
   * Delete
   */
  delete = (url: string, configs?: AxiosRequestConfig): any => {
    return axios.delete(url, { ...configs });
  };

  /*
   file upload update method
   */
  updateWithFile = (url: string, data: any) => {
    const formData = new FormData();
    for (const k in data) {
      formData.append(k, data[k]);
    }
    const config = {
      headers: {
        ...axios.defaults.headers,
        "content-type": "multipart/form-data",
      },
    };
    return axios.put(url, formData, config);
  };

  /*
   file upload post method
   */
  createWithFile = (url: string, data: any) => {
    const formData = new FormData();
    for (const k in data) {
      formData.append(k, data[k]);
    }
    const config = {
      headers: {
        ...axios.defaults.headers,
        "content-type": "multipart/form-data",
      },
    };
    return axios.post(url, formData, config);
  };
}

export { APIClient, setAuthorization };
